module.exports = __webpack_public_path__ + "images/b92fd3626f79c8cd904e0cad3f1813a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/thesuperlatives-characters02.jpg
// module id = ./webpack/assets/img/thesuperlatives-characters02.jpg
// module chunks = 0